function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMagnifiedA(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#DB2B42"
    },
    points: "431.128,512 498.176,447.08 448.792,397.696 382.808,463.68  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DB2B42"
    },
    d: "M363.984,405.944l27.072-27.072l-26.792-26.792c-9.12,9.016-19.064,17.208-29.736,24.4 L363.984,405.944z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "gray"
    },
    points: "344.528,425.4 382.808,463.68 382.808,463.68 448.792,397.696 410.512,359.416  391.056,378.872 363.984,405.944  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D2D2D"
    },
    d: "M425.376,205.776C425.376,92.128,333.248,0,219.6,0S13.824,92.128,13.824,205.776 S105.952,411.544,219.6,411.544c42.568,0,82.112-12.928,114.928-35.064c10.672-7.2,20.616-15.384,29.736-24.4 C401.984,314.776,425.376,263.016,425.376,205.776z M35.392,205.776c0-101.736,82.472-184.208,184.208-184.208 s184.208,82.472,184.208,184.208S321.336,389.984,219.6,389.984S35.392,307.512,35.392,205.776z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "180.912,212.312 245.76,212.312 213.408,134.576  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M403.808,205.776c0-101.736-82.472-184.208-184.208-184.208S35.392,104.04,35.392,205.776 S117.864,389.984,219.6,389.984S403.808,307.512,403.808,205.776z M319.304,284.808H247.52v-5.24 c8.248-0.728,13.568-1.624,15.952-2.672c2.384-1.056,3.584-3.632,3.584-7.752c0-1.368-0.456-3.792-1.376-7.272 c-0.92-3.472-2.2-7.136-3.864-10.976l-11.296-27.152h-74.392C168.8,242.208,164.416,253.48,163,257.552 c-1.424,4.072-2.136,7.296-2.136,9.672c0,4.752,1.92,8.048,5.784,9.88c2.384,1.096,6.872,1.92,13.48,2.464v5.24h-55.936v-5.24 c7.256-0.816,12.704-3.544,16.336-8.192c3.624-4.648,9.848-17.344,18.656-38.112l58.8-138.52h5.624l70.328,160.024 c4.688,10.6,8.432,17.152,11.232,19.664s7.512,4.224,14.128,5.136v5.24H319.304z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DB2B42"
    },
    d: "M293.944,254.768L223.616,94.744h-5.624l-58.8,138.52c-8.808,20.768-15.032,33.464-18.656,38.112 c-3.632,4.648-9.072,7.376-16.336,8.192v5.24h55.936v-5.24c-6.608-0.544-11.096-1.368-13.48-2.464 c-3.864-1.832-5.784-5.12-5.784-9.88c0-2.376,0.712-5.6,2.136-9.672c1.424-4.072,5.8-15.336,13.128-33.808h74.392l11.296,27.152 c1.656,3.84,2.944,7.504,3.864,10.976c0.92,3.472,1.376,5.904,1.376,7.272c0,4.12-1.192,6.696-3.584,7.752 c-2.384,1.048-7.704,1.944-15.952,2.672v5.24h71.776v-5.24c-6.616-0.912-11.328-2.624-14.128-5.136 C302.368,271.912,298.624,265.36,293.944,254.768z M180.912,212.312l32.496-77.736l32.352,77.736L180.912,212.312L180.912,212.312z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifiedA);
export default __webpack_public_path__ + "static/media/magnified-a.4b850febf532532ebbbe8beaeb92fc5c.svg";
export { ForwardRef as ReactComponent };